{
  "COMMON": {
    "LOADING": "Идет загрузка...",
    "ERROR_CODE": {
      "ALXXX": "К сожалению, в данный момент мы не можем найти другие рейсы. Выберите другой вариант или повторите попытку позже. Вы также можете связаться с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "COXXX_1": "К сожалению, в данный момент мы не можем оформить ваше бронирование. Повторите попытку позже. [Код ошибки {{errorCode}}]",
      "COXXX_2": "К сожалению, в данный момент мы не можем идентифицировать ваше бронирование. Повторите попытку позже или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "DIXXX": "К сожалению, в данный момент мы не можем обработать ваш запрос. Повторите попытку позже или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "EMXXX": "К сожалению, не удалось отправить электронное письмо. Повторите попытку позже. [Код ошибки {{errorCode}}]",
      "EXXXX": "К сожалению, в данный момент мы не можем обработать ваш запрос. Повторите попытку позже или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "EX115": "К сожалению, в данный момент мы не можем обработать ваш запрос. Повторите попытку через 15 минут или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки{{errorCode}}]",
      "EX197": "При проведении возврата возникла проблема. Повторите попытку или обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы</a>.",
      "OFXXX": "К сожалению, в данный момент мы не можем оформить ваше бронирование. Повторите попытку позже. [Код ошибки {{errorCode}}]",
      "SEXXX": "К сожалению, в данный момент мы не можем оформить ваше бронирование. Повторите попытку позже. [Код ошибки {{errorCode}}]",
      "SGXXX": "К сожалению, в данный момент мы не можем обработать ваш запрос. Повторите попытку позже или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "SHXXX": "К сожалению, в данный момент мы не можем найти другие рейсы. Выберите другой вариант или повторите попытку позже. Вы также можете связаться с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "RFXXX": "К сожалению, в данный момент мы не можем обработать ваш запрос. Повторите попытку позже или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a> [Код ошибки {{errorCode}}]",
      "REBOOKING_TIMED_OUT": "Время ожидания запроса на повторное бронирование истекло, но мы всё ещё обрабатываем его. Если вы не получите электронное письмо с подтверждением в течение нескольких минут, повторите попытку позже или свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a>"
    },
    "SPREEDLY_ERROR_CODE": {
      "ACCOUNT_INACTIVE": "Не удалось обработать платеж. Убедитесь, что вы используете действительную тестовую карту, или обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы</a>.",
      "BLANK": "Отсутствуют данные в обязательном поле. Введите все необходимые платежные данные и повторите попытку.",
      "INVALID": "Введенные платежные данные недействительны. Проверьте указанные поля и повторите попытку.",
      "BLANK_CARD_TYPE": "Введенный номер кредитной карты недействителен. Проверьте номер карты и повторите попытку.",
      "EXPIRED": "Срок действия указанного способа оплаты истек. Укажите актуальный способ оплаты и повторите попытку.",
      "UNKNOWN_REFERRER": "Не удалось проверить источник запроса на выполнение платежа. Повторите попытку или обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a>.",
      "INVALID_REFERRER": "Не удалось обработать запрос на выполнение платежа из-за проблем безопасности. Повторите попытку или обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a>.",
      "INVALID_ENVIRONMENT_KEY_PARAMETER": "Непредвиденная ошибка. Обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы</a>."
    },
    "BUTTON": {
      "CONTINUE": "Продолжить",
      "BACK": "Назад",
      "CLOSE": "Закрыть"
    },
    "PRODUCT_NAME": "Помощь при срыве планов",
    "FLIGHT_INFORMATIONS": {
      "LAYOVER": "Ожидание {{time}} в {{airportName}} ({{airportCode}})",
      "STATUS": {
        "CANCELLED": "Отменен",
        "DELAYED": "Задержан",
        "FLOWN": "Выполнен",
        "BOARDED": "Посадка завершена",
        "CONFIRMED": "Подтвержден"
      },
      "CABIN": {
        "ECONOMY": "Экономкласс",
        "PREMIUM_ECONOMY": "Премиум-эконом",
        "BUSINESS": "Бизнес",
        "FIRST": "Первый класс"
      },
      "NO_STOP": "Прямой",
      "STOP": {
        "ZERO": "{{count}} пересадки в {{destinations}}",
        "ONE": "{{count}} пересадка в {{destinations}}",
        "TWO": "{{count}} пересадки в {{destinations}}",
        "FEW": "{{count}} пересадки в {{destinations}}",
        "MANY": "{{count}} пересадки в {{destinations}}",
        "OTHER": "{{count}} пересадки в {{destinations}}"
      },
      "FLIGHT": "Рейс",
      "OUTBOUND_FLIGHT": "Рейс туда",
      "INBOUND_FLIGHT": "Рейс обратно",
      "REBOOKED_BY_AIRLINE": "Перебронировано {{partnerName}}",
      "PASSENGER_TYPE": {
        "ADULT": {
          "ZERO": "Взрослых: {{count}}",
          "ONE": "{{count}} взрослый",
          "TWO": "Взрослых: {{count}}",
          "FEW": "Взрослых: {{count}}",
          "MANY": "Взрослых: {{count}}",
          "OTHER": "Взрослых: {{count}}"
        },
        "CHILD": {
          "ZERO": "Детей: {{count}}",
          "ONE": "{{count}} ребенок",
          "TWO": "Детей: {{count}}",
          "FEW": "Детей: {{count}}",
          "MANY": "Детей: {{count}}",
          "OTHER": "Детей: {{count}}"
        },
        "SEATED_INFANT": {
          "ZERO": "Младенцев с местом: {{count}}",
          "ONE": "{{count}} младенец с местом",
          "TWO": "Младенцев с местом: {{count}}",
          "FEW": "Младенцев с местом: {{count}}",
          "MANY": "Младенцев с местом: {{count}}",
          "OTHER": "Младенцев с местом: {{count}}"
        },
        "LAP_INFANT": {
          "ZERO": "Младенцев без места: {{count}}",
          "ONE": "{{count}} младенец без места",
          "TWO": "Младенцев без места: {{count}}",
          "FEW": "Младенцев без места: {{count}}",
          "MANY": "Младенцев без места: {{count}}",
          "OTHER": "Младенцев без места: {{count}}"
        }
      }
    },
    "REFUND": {
      "DEFAULT_HEADER": {
        "TITLE": "Получить возврат",
        "SUBTITLE": "Вы получите <b>{{amount}}</b> (100% от покрытой услугой суммы бронирования) в качестве возврата денежных средств. Возврат не повлечет никаких изменений в вашем бронировании у {{partnerName}}, поэтому вы также можете совершить перелет исходным рейсом.<br /><br />Подтвердите вашу информацию, чтобы мы могли произвести возврат."
      },
      "CONFIRMATION_HEADER": {
        "TITLE": "Выполнено! Возврат в размере <b>{{amount}}</b> обрабатывается.",
        "SUBTITLE": "Электронное письмо с подтверждением будет отправлено на адрес <b>{{email}}</b> в ближайшее время. За вами по-прежнему сохраняется исходное бронирование авиабилета. Благодарим за использование услуги «{{productName}}»!"
      },
      "FORM_HEADER": {
        "PERSONAL_INFORMATION": "Персональные данные",
        "HOME_ADDRESS_INFORMATION": "Домашний адрес"
      },
      "FORM": {
        "FIRST_NAME": "Имя",
        "LAST_NAME": "Фамилия",
        "ADDRESS_LINE_1": "Адрес, строка 1",
        "ADDRESS_LINE_2": "Адрес, строка 2 (необязательно)",
        "CITY": "Город",
        "COUNTRY": "Страна",
        "STATE": "Область/регион",
        "ZIP": "Почтовый индекс"
      }
    },
    "GENDER": {
      "MALE": "Мужской",
      "FEMALE": "Женский",
      "UNDISCLOSED": "Не известен",
      "UNSPECIFIED": "Не указан"
    }
  },
  "HOME": {
    "CONTRACT_ALREADY_REFUNDED": "Запрос на отмену принят, и мы обрабатываем возврат средств. Если вам нужна помощь, свяжитесь с нашей службой поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a>",
    "NO_DISRUPTION": "Задержки или отмены рейсов не обнаружено."
  },
  "NOT_FOUND": {
    "TITLE": "Страница не найдена",
    "MESSAGE": "Извините. Страница, которую вы ищете, не найдена.",
    "GO_HOME": "На главную"
  },
  "SERVICE_DISRUPTION_STEP": {
    "TITLE": "Сервис временно недоступен",
    "MESSAGE": "В работе сервиса произошел сбой, но он будет устранен в ближайшее время.",
    "TRY_AGAIN": "Повторите попытку через несколько часов.",
    "CONTACT_CUSTOMER_SUPPORT": "Связаться со службой поддержки"
  },
  "FLIGHT_INFORMATIONS": {
    "NOT_ELIGIBLE": "Мы отслеживаем ваш рейс. Воспользуйтесь услугой, если столкнетесь с задержкой рейса более чем на {{minMinutesDelay}} минут или его отменой, в течение {{maxHoursBeforeDeparture}} часов со времени вылета.",
    "CHOICE_SELECTION": "Что вы хотели бы сделать?",
    "REBOOK": {
      "TITLE": "Забронировать новый авиабилет",
      "DESC": "Вы можете забронировать авиабилет на новый рейс любой авиакомпании с вылетом сегодня или завтра."
    },
    "REFUND": {
      "TITLE": "Получить возврат и лететь исходным рейсом",
      "DESC": "Если вас не устраивают варианты, предложенные для повторного бронирования, получите возврат в размере <b>{{amount}}</b> и продолжите путешествие исходным рейсом."
    }
  },
  "PRODUCT_INFORMATIONS": {
    "PRODUCT_INFO": "Поскольку вы приобрели услугу «{{productName}}», вы имеете право на повторное бронирование или (если вас не устраивают предложенные нами варианты) возврат средств в течение {{maxHoursBeforeDeparture}} часов со времени вылета, если ваш рейс был отменен или задержан более чем на {{minMinutesDelay}} минут."
  },
  "SLICE_DETAILS_DIALOG": {
    "TITLE": "Рейс в {{destination}}"
  },
  "SLICE_INFORMATIONS": {
    "ELIGIBLE_FOR_REBOOKING": "Доступен для повторного бронирования",
    "NOT_ELIGIBLE_FOR_REBOOKING": "Недоступен для повторного бронирования"
  },
  "SEND_VERIFICATION_CODE_STEP": {
    "SEND_VERIFICATION_TITLE": "Давайте убедимся, что это действительно вы",
    "SEND_VERIFICATION_TEXT": "Мы отправим код на электронную почту, которую вы использовали при бронировании.",
    "BUTTON": {
      "SEND_VERIFICATION_CODE": "Отправить код"
    }
  },
  "CHECK_VERIFICATION_CODE_STEP": {
    "CHECK_VERIFICATION_TITLE": "Давайте убедимся, что это действительно вы",
    "CHECK_VERIFICATION_TEXT": "Мы отправили электронное письмо с кодом подтверждения на {{email}}.",
    "BUTTON": {
      "RESEND_VERIFICATION_CODE": "Отправить новый код"
    }
  },
  "HYPERWALLET_FORM_STEP": {
    "FORM": {
      "MIDDLE_NAME": "Отчество (необязательно)",
      "DATE_OF_BIRTH": "Дата рождения"
    }
  },
  "HYPERWALLET_REFUND_STEP": {
    "RECEIVE_AMOUNT_TITLE": "Как вы предпочитаете получить возврат средств?"
  },
  "SPREEDLY_FORM_STEP": {
    "CARD_INFORMATION": "Данные карты",
    "FORM": {
      "FULL_NAME": "Имя и фамилия",
      "CARD_NUMBER": "Номер карты",
      "EXPIRATION_MONTH": "Месяц окончания действия",
      "EXPIRATION_YEAR": "Год окончания действия",
      "CVV": "CVV"
    },
    "BUTTON": {
      "REDIRECT_TO_BANK_TRANSFER": "У меня нет кредитной карты"
    }
  },
  "BANK_TRANSFER_FORM_STEP": {
    "DESC": "Мы вернем средства на ваш банковский счет.",
    "FORM": {
      "BANK_INFORMATION": "Реквизиты банковского счета",
      "ACCOUNT_NUMBER": "IBAN / номер банковского счета",
      "BANK_ID": "SWIFT/BIC-код",
      "ACCOUNT_HOLDER_INFORMATION": "Информация о владельце счета",
      "VALIDATION": {
        "REQUIRED": "Это поле обязательно для заполнения",
        "INVALID_IBAN": "Введите действительный номер IBAN",
        "INVALID_BIC": "Введите действительный SWIFT/BIC-код",
        "formValidationAccountNumberRequired": "Введите номер своего банковского счета.",
        "formValidationBankCodeRequired": "Введите код банка.",
        "formValidationBankCodeLength": "Код банка должен содержать от 8 до 11 символов.",
        "formValidationBankCodeFirstChars": "Код банка должен начинаться с 4 букв.",
        "formValidationBankCodeCountryUnsupported": "Страна в этом коде банка не поддерживается для международных переводов.",
        "formValidationBankCodeCountryInvalid": "Код страны в коде банка недействителен.",
        "formValidationBankCodeLocationInvalid": "Код местоположения в коде банка недействителен.",
        "formValidationBankCodeBranchInvalid": "Код филиала в коде банка недействителен.",
        "formValidationIbanCharsInvalid": "Номер банковского счета содержит недопустимые символы. Используйте только буквы и цифры.",
        "formValidationIbanCountryInvalid": "Номер банковского счета должен начинаться с действительного кода страны.",
        "formValidationIbanCountryUnsupported": "Страна в этом номере банковского счета не поддерживается для международных переводов.",
        "formValidationIbanLengthInvalid": "Номер банковского счета имеет недопустимую длину для этой страны.",
        "formValidationIbanChecksumInvalid": "Номер банковского счета недействителен. Проверьте и повторите попытку.",
        "formValidationIbanBicCountryMismatch": "Страна в номере банковского счета не совпадает со страной в коде банка."
      }
    }
  },
  "PAYOUT_ERROR_STEP": {
    "TITLE": "Не удалось обработать запрос по услуге «{{productName}}»",
    "SUBTITLE": "При проведении возврата возникла проблема. Приносим извинения за неудобства. Нажмите <b>Продолжить</b> и посмотрите, какие способы проведения возврата доступны. Если возникли проблемы, обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы</a>.",
    "NO_PAYOUT_OPTIONS": "Обратитесь в службу поддержки с помощью <a href='{{link}}' target='_blank'>этой формы.</a>"
  },
  "REBOOKING_CONFIRMATION_STEP": {
    "TITLE": "Устройтесь поудобнее и расслабьтесь! Ваше новое бронирование подтверждено",
    "SUBTITLE": "Электронное письмо с подтверждением будет отправлено на адрес {{email}} в ближайшее время. Благодарим за использование услуги «{{productName}}»!",
    "YOUR_NEW_FLIGHT": "Новый рейс"
  },
  "REBOOKING_FORM_STEP": {
    "TITLE": "Информация о пассажире",
    "SUBTITLE": "Подтвердите вашу информацию перед повторным бронированием авиабилета.",
    "LOADING_REBOOK": "Выполняется повторное бронирование...",
    "PASSENGER": "Пассажир {{index}}",
    "BUTTON": {
      "SUBMIT": "Подтвердить и перебронировать"
    },
    "FORM": {
      "FIRST_NAME": "Имя",
      "LAST_NAME": "Фамилия",
      "GENDER": "Пол",
      "PASSPORT_NUMBER": "Номер паспорта",
      "COUNTRY_ISSUANCE": "Страна выдачи",
      "NATIONALITY": "Гражданство",
      "ISSUANCE_DATE": "Дата выдачи",
      "EXPIRATION_DATE": "Срок действия",
      "DATE_OF_BIRTH": "Дата рождения"
    }
  },
  "REBOOKING_REVIEW_STEP": {
    "TITLE": "Перебронировать авиабилет",
    "SUBTITLE": "Вы можете бесплатно забронировать новый авиабилет (стоимостью до {{serviceCap}} на пассажира), выбрав рейсы с вылетом в тот же или на следующий день. Если вы выберете новый рейс, ваш исходный авиабилет {{partnerName}} будет аннулирован, но вы сможете воспользоваться рейсами в обратном направлении (если это применимо).",
    "LOADING_REBOOK": "Выполняется повторное бронирование...",
    "CHOICE_SUMMARY": "Ниже приведена краткая информация о вашем выборе.",
    "DIFFERENT_AIRPORT": "Проверьте маршрут, поскольку аэропорты вылета или прибытия в нем отличаются от исходного авиабилета."
  },
  "REBOOKING_SEARCH_ALTERNATIVES_STEP": {
    "TITLE": "Перебронировать авиабилет",
    "SUBTITLE": "Вы можете бесплатно забронировать новый авиабилет (стоимостью до {{serviceCap}} на пассажира), выбрав рейсы с вылетом в тот же или на следующий день. Если вы выберете новый рейс, ваш исходный авиабилет {{partnerName}} будет аннулирован, но вы сможете воспользоваться рейсами в обратном направлении (если это применимо).",
    "LOADING_REBOOK": "Выполняется повторное бронирование...",
    "LOADING_ALTERNATIVES": "Подождите, пока мы загрузим доступные вам варианты повторного бронирования.",
    "ONE_MORE_ALTERNATIVE": "Ещё {{nbAlternative}} вариант",
    "MORE_ALTERNATIVES": "Ещё {{nbAlternative}} варианта",
    "NO_ALTERNATIVE": "К сожалению, на данный момент нет доступных рейсов на этот день вылета. Вы можете выбрать один из следующих вариантов: ",
    "BAGS_TITLE": "У вас есть регистрируемый багаж?",
    "BUTTON": {
      "YES": "Да",
      "NO": "Нет",
      "GO_TO_REFUND_FLOW": "Выбрать вариант возврата",
      "SEARCH_FOR_OTHER_DAY": "Искать рейсы на день раньше или позже"
    },
    "OUTBOUND": "Рейс в {{destination}}",
    "NO_STOP": "Прямой",
    "STOP": {
      "ZERO": "{{count}} пересадки",
      "ONE": "{{count}} пересадка",
      "TWO": "{{count}} пересадки",
      "FEW": "{{count}} пересадки",
      "MANY": "{{count}} пересадки",
      "OTHER": "{{count}} пересадки"
    },
    "SEE_OTHER_AIRLINES": "Показать больше авиакомпаний"
  },
  "WARNING_BAGS_DIALOG": {
    "TITLE": "Важное уведомление о зарегистрированном багаже",
    "DESC": "Поскольку вы уже зарегистрировали несколько мест багажа на задержанный или отмененный рейс данной авиакомпании, их необходимо выгрузить и зарегистрировать на новый рейс. Для этого обратитесь на стойку регистрации авиакомпании в аэропорту.<br /><br />Мы не можем гарантировать своевременную выгрузку вашего багажа для регистрации на новый рейс.",
    "DESC_FLYADEAL": "Поскольку вы уже зарегистрировали несколько мест багажа на отмененный или отмененный рейс данной авиакомпании, их необходимо выгрузить и зарегистрировать на новый рейс. Для этого обратитесь в службу поддержки авиакомпаний или службу выдачи багажа в аэропорту для получения багажа.<br /><br />Вы несете ответственность за своевременный сбор и проверку багажа на новом рейсе.",
    "BUTTON": {
      "REFUND": "Воспользоваться авиабилетом и получить возврат средств",
      "REBOOK": "Перебронировать и самостоятельно отвечать за багаж"
    }
  },
  "ALTERNATIVE_DETAILS_DIALOG": {
    "TITLE": "Рейс в {{destination}}",
    "BUTTON": {
      "SUBMIT": "Выбрать этот рейс"
    }
  }
}
